module.exports = __webpack_public_path__ + "img/thumb_25.f3e2ff09.jpg";